import { Calendar } from 'lucide-react';
import FieldError from '../FieldError';
import { localTodayISO } from '../intakeConstants';

export default function DateStep({ formData, errors, handleChange }) {
  const max = localTodayISO();
  const openPicker = () => {
    const el = document.getElementById('date-of-loss-input');
    if (el) {
      try { el.showPicker(); } catch { el.focus(); }
    }
  };
  return (
    <div>
      <label className="text-blue-500 text-2xl font-bold mb-6 block">Date Of Loss</label>
      <div className="relative cursor-pointer" onClick={openPicker}>
        <input
          id="date-of-loss-input"
          type="date"
          max={max}
          value={formData.dateOfLoss}
          onChange={(e) => handleChange('dateOfLoss', e.target.value)}
          className="absolute inset-0 opacity-0 w-full h-full cursor-pointer z-10"
          data-testid="date-of-loss-native"
        />
        <div
          className={`w-full bg-white h-12 text-lg pr-12 flex items-center px-3 border rounded-md ${
            errors.dateOfLoss ? 'border-red-500' : 'border-gray-200'
          }`}
        >
          <span className={formData.dateOfLoss ? 'text-gray-900' : 'text-gray-400'}>
            {formData.dateOfLoss
              ? `${formData.dateOfLoss.slice(5, 7)}/${formData.dateOfLoss.slice(8, 10)}/${formData.dateOfLoss.slice(0, 4)}`
              : 'MM/DD/YYYY'}
          </span>
        </div>
        <Calendar className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 w-6 h-6 pointer-events-none" />
      </div>
      <FieldError message={errors.dateOfLoss} />
    </div>
  );
}
